import router from './router'
import store from './store'
import { Message, MessageBox } from 'element-ui'
// import i18n from './lang'
// 引用axios，并设置基础URL为后端服务api地址
var axios = require('axios')
import qs from 'qs'
import Cookies from 'js-cookie'
import _ from 'lodash';
axios.defaults.baseURL = '/explorer';
axios.defaults.timeout = 360000;
// axios.defaults.withCredentials = true;

//设置全局，每次ajax请求携带cookies
// axios.defaults.withCredentials = true

// 获取CancelToken
const CancelToken = axios.CancelToken;
var source = CancelToken.source();

// 转换请求方式
/* axios.defaults.transformRequest = [function(data) {
  return qs.stringify(data, { allowDots: true })
}] */

// http request 拦截器
axios.interceptors.request.use(
  config => {
    config.headers.lang = 'zh_CN';
    config.headers.version = 'gn';
    // 若store中无token，查询localStorage中是否存在，存在则更新store中token信息
    if (store.state.user.token) {
      config.headers.Authorization = store.state.user.token; //将token设置成请求头
      store.commit('user/setToken', store.state.user.token);
    } else if (localStorage.getItem('token')) {
      config.headers.Authorization = localStorage.getItem('token'); //将token设置成请求头
      store.commit('user/setToken', localStorage.getItem('token'));
    } else {
      store.commit('user/updateLogined', false);
      if (config.url.indexOf('/login/userLogin') == -1 && (router.currentRoute.path == "/dataSearchMain" || router.currentRoute.name == "DataSearchMain")) {
        let grantMsg = '未授权';
        let againLogin = '请重新登录！';
        Message.closeAll();
        // Message.error(msg)
        let message = Message({
          dangerouslyUseHTMLString: true,
          message: grantMsg + ' ， <el-link class="el-link el-link--primary" style="text-decoration: underline; cursor:pointer">' + againLogin + '</el-link> ',
          showClose: true,
          type: 'error',
          duration: 4000
        });
        // 给提示信息添加点击事件
        message.$el.querySelector('el-link').onclick = () => {
          Message.closeAll();
          router.replace({ path: '/home' });
        }
        // return Promise.reject(msg);
      }
    }
    // config.headers['Access-Control-Allow-Origin'] = '*'; //跨域问题
    // 全局添加cancelToken
    config.cancelToken = source.token;
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

// http response 拦截器
axios.interceptors.response.use(
  response => {
    if (response.data.code === "401") {
      // 某个请求的响应满足特定条件的情况下，取消其他正在进行的请求
      if (router.currentRoute.path != "/home") {
        source.cancel();
      }
      store.commit('user/logOut');
      router.replace({
        path: '/home',
        query: { msg: response.data.message }
      })

      return Promise.resolve(response.data);

    } else if (response.data.code == undefined) {
      store.commit('user/updateLogined', false);
      return response;
    } else {
      return response;
    }
  },
  error => {
    if (error.message.includes('timeout')) {   // 判断请求异常信息中是否含有超时timeout字符串
      console.log("网络超时", error);
      Message.closeAll();
      Message.error('网络超时')
      return Promise.reject(error);          // reject这个错误信息
    }
    if (error.message.includes('504')) {
      Message.closeAll();
      Message.error('服务器未响应,请联系管理员！')
      return Promise.reject(error);          // reject这个错误信息
    }
    if (axios.isCancel(error)) { // 取消请求的情况下，终端Promise调用链
      return new Promise(() => { });
    } else {
      return Promise.reject(error);
    }
  }
);

router.beforeEach(async (to, from, next) => {
  document.title = '世纪智云遥感影像在线服务平台'
  if (to.meta.requireAuth) { // 判断是否有权限
    let token = localStorage.getItem('token');
    let storageToken = store.state.user.token;
    if (token || storageToken) { // 获取当前的token是否存在
      store.commit('user/setToken', storageToken ? storageToken : token);
      store.commit('user/updateLogined', true);
      next();
    } else {
      store.commit('user/logOut');
      next({
        path: '/home', // 将跳转的路由path作为参数，登录成功后跳转到该路由
        query: { msg: '未授权，请重新登录！' }
      })
    } 
  }else {
    next();
  }
  source = CancelToken.source();

});

/* 页面跳转默认回到顶部 */
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
})
// 第二个代理基础路径配置
export const service = axios.create({
  baseURL: '/service'
});
// 第二个代理基础路径配置
// export const mapcube = axios.create({
//   baseURL: '/mapcube'
// });

export default axios;



// WEBPACK FOOTER //
// ./src/http.js